<div *ngIf="isOpen" class="modal-overlay" (click)="closeModal()">
    <div class="modal-container" (click)="stopPropagation($event)">
      <div class="modal-header">
        <div class="name-date"> 
          <span class="modal-title">{{ title }}</span>
        </div>
        <span class="modal-close" (click)="closeModal()">&times;</span>
      </div>
      <div class="modal-body">
        <ng-content></ng-content>
      </div>
    </div>
  </div>
  
